module.exports = __webpack_public_path__ + "img/jf_home_14.089d08a4.jpg";